import React from 'react';
import Speciality02 from '../components/SpecialityElements/Speciality02';
import Testimonial from '../components/Testimonial';
import Clients from '../components/common/Clients';
import Timeline from '../components/common/Timeline';
import Timeline02 from '../components/common/Timeline02';
import PageHeader from './Shared/PageHeader';

const About = () => {
    return (
        <div>
            <PageHeader title="About Hungrybuzz" />

            <div className="main-wrapper">
                <div className="about_top_sec">
                    <div className="container">
                        <div className="about_header">
                            <div className="row">
                                <div className="col-lg-5">
                                    <div className="about_header_title">
                                        <h1 data-aos="fade-right" data-aos-duration="1000">About Us</h1>
                                        <h3>We have Started Our Journey to
                                            serve you from 1975</h3>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about_header_desc">
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elittempor incididunt ut labore et dolore
                                            magna aliqua. Ut enad minim veniam, quis nostrud exercitation ullamco lab aliquip ex ea co
                                            mmodo consequat. Penat.sectetur adipiscing elittempor incididunt ut labore et dolore
                                            magna aliqua. Ut enad minim veniam, quis nostrud exercitation ullamco lab aliquip ex ea co
                                            mmodo consequat. Penat.
                                        </p>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elittempor incididunt ut labore et dolore
                                            magna aliqua. Ut enad minim veniam, quis nostrud exercitation ullamco lab aliquip ex ea co
                                            mmodo consequat. Penat.sectetur.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="portfolio_grid">
                            <div className="grid-masonary grid-3 gutter-15 clearfix">
                                <div className="grid-sizer"></div>
                                <div className="row">
                                    <div className="col-lg-4 col-12 grid-item">
                                        <div className="product_thumb mb-3">
                                            <div className="product_imagebox">
                                                <img className="primary_img" src="images/about/1.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-12 grid-item">
                                        <div className="product_thumb mb-4">
                                            <div className="product_imagebox">
                                                <img className="primary_img" src="images/about/2.jpg" alt="img" />
                                            </div>
                                        </div>

                                        <div className="product_thumb">
                                            <div className="product_imagebox">
                                                <img className="primary_img" src="images/about/3.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12 grid-item">

                                        <div className="product_thumb mb-4">
                                            <div className="product_imagebox">
                                                <img className="primary_img" src="images/about/4.jpg" alt="img" />
                                            </div>
                                        </div>


                                        <div className="product_thumb">
                                            <div className="product_imagebox">
                                                <img className="primary_img" src="images/about/5.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                        <div className="grillman_imgtext">
                            <img src="images/about/grillman.png" alt="" data-aos="fade-up" data-aos-duration="1000" />
                            <p>Hungrybuzz Restaurant</p>
                        </div>
                    </div>
                </div>

                <Speciality02></Speciality02>
                <div className="section bg_image_3">
                    <Testimonial></Testimonial>
                </div>
                <Timeline02></Timeline02>
                <Timeline></Timeline>
                <Clients></Clients>

            </div>
        </div>
    );
};

export default About;